export default __webpack_public_path__ + "static/media/DP3 1C-2E.aa2b65e1.jpg";